module.exports = __webpack_public_path__ + "img/33.a767be55.png";